<template lang="pug">
  .table-responsive
    table#tbConsumibles.table.is-striped.is-fullwidth
      thead
        tr
          th Descripción
          th Fecha
          th Usuario
          th Ubicación
          th Permiso
          th Evidencias
      tbody
        tr(v-for="(data, index) in actividades" :key="data.id")
          td
            span.tag.is-black
              | {{ data.id }}
            br
            small {{data.nombre }}
          td
            | {{ data.fecha_Fin }}
          td
            | {{ data.ejecuto }}
          td
            | {{ data.ubicacion }}
          td
            | {{ data.permiso }}
          td
          td.has-text-centered(width='200px')
            carousel(
              :per-page="1", 
              :mouse-drag="false",
              :autoplay="true",
              :autoplayTimeout="3500",
            )
              slide(v-for="evid in data.evidencias" :key="evid.idEvid")
                figure.image.is-150x150
                  img.is-redondeado(:src="convertirRuta(evid.rutaEvid)")
</template>

<script>
  import moment from 'moment' 
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: 'TbActivades',
    components: { Carousel, Slide },
    props: {
      actividades: {
        type: Array,
        default: []
      },
    },
    methods: {
      convetirEstado (estado) {
        switch (estado) {
          case '5':
            return 'Programada'
            break
          case '0':
            return 'Abierta'
            break
          case '1':
            return 'En Revisión'
            break
          case '2':
            return 'Finalizda'
            break
          case '6':
            return 'Reprogramada'
            break
        
          default:
            break
        }
      },
      convertirRuta (ruta) {
        var currentUrl = window.location.hostname
        console.log(currentUrl)
        let api_url = ''
        if (currentUrl === '10.121.40.125') {
          api_url = '10.121.40.125'
        } else {
          api_url = currentUrl
        }
        return `https://${api_url}/reportesApp/${ruta}`
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/resumen_Componentes/TbActividades.vue